import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';
import { BigPicklistInput } from 'Packages/FacetDesign/Components';
import {
  AccountOpeningV2BeneficiaryIntroStepLayout,
} from './AccountOpeningV2BeneficiaryIntroStepLayout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md' },
  }, overrideReadOnly)
  .nameOverride('beneficiaries', {
    _component: () => BigPicklistInput,
  }, overrideReadOnly);

export const AccountOpeningV2BeneficiaryIntroStep = () => {
  const { pageContentResource, setPageContentCollection } = usePageContentContext();

  return (
    <MetaResourceRenderer
      layout={AccountOpeningV2BeneficiaryIntroStepLayout}
      resource={pageContentResource}
      onSubmit={setPageContentCollection}
      metaOverrideSet={metaOverrideSet}
    />
  );
};
